module.exports = __webpack_public_path__ + "img/housesin-logo.bc60ec75.png";